import { useNavigate, Link } from "react-router-dom";
export default function TpStudioLoader({ displayLoader = false }) {
  return (
    displayLoader && <div
      className="text-center mt-10"
      id="beforeAnimation"
      style={{ background: "#000" }}
    >
      <img src="/assets/images/casinoloadinggif.gif" alt="Loading..." />
    </div>
  );
}
